const getOrigin = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
};

const normalizeUrl = (value, fallback) => {
  const candidate = value || fallback;
  if (!candidate) return "";
  return candidate.replace(/\/+$/, "");
};

const isDevHost = () => (
  typeof window !== "undefined" &&
  window.location.hostname.startsWith("dev-")
);

const defaultWebsiteBaseUrl = isDevHost()
  ? "https://dev.wannapractice.com"
  : "https://wannapractice.com";

const defaultAppBaseUrl = getOrigin();

export const websiteBaseUrl = normalizeUrl(
  process.env.REACT_APP_WEBSITE_BASE_URL,
  defaultWebsiteBaseUrl
);

export const appBaseUrl = normalizeUrl(
  process.env.REACT_APP_APP_BASE_URL,
  defaultAppBaseUrl
);

export const imagePath = (path) => {
  if (typeof path !== "string") return "";
  return `/i${path.startsWith("/") ? path : `/${path}`}`;
};
